export default "__VITE_ASSET__DUN6ym3A__"